import { ICommonIconProps } from './types';
/**
 * -----------------------------------------------------------------------------
 * It renders a pen icon over phrase, which looks like phrase writing.
 */
export function PenLineIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 20 20">
      <path
        clipRule="evenodd"
        d="m5.244 10.59 5.345-5.346a.832.832 0 0 0 0-1.178L9.267 2.744a.832.832 0 0 0-1.178 0L2.744 8.09a.833.833 0 0 0-.244.59v2.155h2.155c.22 0 .433-.088.59-.245v0Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.834h7.5M2.5 14.167h15M2.5 17.5h15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
